import { useMemo, useState } from "react";
import { Check, ChevronsUpDown, Search } from "lucide-react";
import { rp } from "@/lib/format";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export default function ProductCombobox({ products, value, onChange, testId = "product-combobox", placeholder = "Ketik nama produk…" }) {
  const [open, setOpen] = useState(false);
  const selected = useMemo(() => products.find((p) => p.product_id === value), [products, value]);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" role="combobox" aria-expanded={open} data-testid={testId}
          className="flex h-10 w-full items-center justify-between rounded-md border border-input bg-white px-3 py-2 text-sm text-left no-up">
          {selected ? <span className="truncate data-raw"><b>{selected.product_name}</b> <span className="text-slate-500 mono text-xs">· {rp(selected.default_sewing_rate)}/pcs</span></span>
            : <span className="text-slate-400 inline-flex items-center gap-1.5"><Search className="w-3.5 h-3.5" />{placeholder}</span>}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[min(92vw,440px)]" align="start">
        <Command filter={(v, s) => (v.toLowerCase().includes(s.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Cari nama / kode produk…" data-testid={`${testId}-search`} className="no-up" />
          <CommandList className="max-h-72">
            <CommandEmpty>Produk tidak ditemukan</CommandEmpty>
            <CommandGroup>
              {products.map((p) => (
                <CommandItem key={p.product_id} value={`${p.product_name} ${p.product_code}`} onSelect={() => { onChange(p.product_id, p); setOpen(false); }}
                  data-testid={`${testId}-item-${p.product_id}`} className="no-up flex items-center justify-between gap-3 py-2">
                  <span className="flex items-center gap-2 min-w-0">
                    <Check className={`w-3.5 h-3.5 shrink-0 ${value === p.product_id ? "opacity-100 text-[#0071E3]" : "opacity-0"}`} />
                    <span className="min-w-0"><div className="data-raw text-sm font-medium truncate">{p.product_name}</div><div className="text-[10px] text-slate-400 mono truncate">{p.product_code}</div></span>
                  </span>
                  <span className={`mono text-xs font-semibold shrink-0 ${p.default_sewing_rate ? "text-slate-700" : "text-amber-600"}`}>{p.default_sewing_rate ? rp(p.default_sewing_rate) : "tarif kosong"}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
